import { z } from 'zod'

const highlightCountsListSchema = z.array(
  z.object({
    keyword: z.string(),
    count: z.number(),
  })
)

export const highlightCountsSchema = z.object({
  title: highlightCountsListSchema,
  abstract: highlightCountsListSchema,
  claims: highlightCountsListSchema,
  descriptions: highlightCountsListSchema,
  total: highlightCountsListSchema,
})

export type SingleHighlightCount = z.infer<
  typeof highlightCountsListSchema
>[number]

export type HighlightCounts = z.infer<typeof highlightCountsSchema>

export type HighlightCountsSection = keyof HighlightCounts
